export default __webpack_public_path__ + "6c5b17f.png";